export default __webpack_public_path__ + "static/media/logo.431eded9.png";